import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
import { CustomDatePickerComponent } from './custom-date-picker.component';
import { FormErrorsModule } from '@spartacus/storefront';
import {CustomIconsModule} from "../../icons/custom-icons.module";

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, I18nModule, CustomIconsModule],

  declarations: [CustomDatePickerComponent],
  exports: [CustomDatePickerComponent],
})
export class CustomDatePickerModule {}
